<template>
  <div class="container">
    <div class="mainHead flex-space-between">
      <router-link class="flex-start" to="/">
        <img src="@/assets/image/logo.png" class="logoImg"/>
        <span class="title">银行联合收单营销平台</span>
      </router-link>
      <div class="flex-start">
        <img class="avatar" :src="avatar || require('@/assets/image/avatar.png')" alt=""/>
        <span class="welcome">欢迎你，{{userName}}({{userId}})</span>
        <span class="handlerSpan" @click="openChangePsd">修改密码</span>
        <span class="handlerSpan" @click="logout()">退出</span>
      </div>
    </div>
    <dialog-info title="修改密码" :visible.sync="showChangePsd" :confirmLoading="changePsdLoading" @confirm="changePsd">
      <el-form :model="passwordForm" label-position="left" :rules="ruleData" label-width="80px" ref="passwordForm">
        <el-form-item label="旧密码" prop="oldPassWord">
          <el-input v-model="passwordForm.oldPassWord" type="password" placeholder="8~20位数字/字母组合" autoComplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassWord">
          <el-input v-model="passwordForm.newPassWord" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合"></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>
    <div class="mainContainer flex-start-start">
      <nav-bar ref="navBarLeft" :value="navBarData"></nav-bar>

      <div class="mainContent light-scroll">
        <tags-view class="tags"></tags-view>
        <keep-alive :include="includeRoute">
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from '@/components/layout/navbar'
import dialogInfo from '@/components/layout/dialogInfo'
import tagsView from '@/components/layout/tagsView'
import { validStrictPsd, strictPsdError } from '@/assets/js/utils'

const md5 = require('md5')
export default {
  name: 'layout',
  components: {
    navBar,
    dialogInfo,
    tagsView
  },
  data () {
    return {
      // userName: '',
      avatar: '',
      refreshAttention: false,
      // navBarData: [],
      showChangePsd: false,
      passwordForm: {
        oldPassWord: '',
        newPassWord: '',
        confirmPassword: ''
      },
      ruleData: {
        oldPassWord: [{
          validator: (rule, value, callback) => {
            if (/^[a-zA-Z0-9]{8,20}$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入8~20位数字/字母组合密码'))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        newPassWord: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        confirmPassword: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(strictPsdError))
            } else if (value !== this.passwordForm.newPassWord) {
              callback(new Error('两次密码不一致!'))
            } else if (validStrictPsd(value)) {
              callback()
            } else {
              callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }]
      },
      changePsdLoading: false
      // userId: ''
    }
  },
  watch: {
    '$route' (val) {
      this.$refs.navBarLeft.$refs.menuLeft.activeIndex = val.path
    }
  },
  mounted () {
    // this.userName = this.$store.getters.getUserName
    // this.userId = this.$store.state.userInfo.userValue
    // this.navBarData = JSON.stringify(this.$store.state.navBar) === '{}' ? [] : this.$store.state.navBar
    this.$refs.navBarLeft.$refs.menuLeft.activeIndex = this.$route.path
  },
  methods: {
    changePsd () {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          const params = {
            oldPassWord: md5(this.passwordForm.oldPassWord),
            newPassWord: md5(this.passwordForm.newPassWord)
          }
          this.changePsdLoading = true
          this.$axios.post(this.$api.changePsd, params).then(res => {
            this.changePsdLoading = false
            if (res.respCode === '0') {
              this.$message({
                type: 'success',
                message: '修改密码成功！'
              })
              this.showChangePsd = false
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    openChangePsd () {
      this.passwordForm = this.$options.data().passwordForm
      this.showChangePsd = true
      setTimeout(() => {
        this.$refs.passwordForm.clearValidate()
      }, 100)
    },
    logout () {
      const that = this
      this.$confirm('确认退出登录？', '温馨提醒', {
      }).then(() => {
        that.$axios.post(that.$api.logout, {}).then(res => {
          if (res.respCode === '0') {
            localStorage.clear()
            that.$store.commit('updateUserInfo', {})
            that.$store.commit('updateNavBar', {})
            that.$store.commit('updateRoot', {})
            that.$router.push('/login')
          }
        })
      }).catch(() => {

      })
    }
  },
  computed: {
    includeRoute () {
      return this.$store.state.visitedViews.map(item => item.name)
    },
    userName () {
      return this.$store.getters.getUserName
    },
    userId () {
      return this.$store.state.userInfo.userValue
    },
    navBarData () {
      const data = JSON.stringify(this.$store.state.navBar) === '{}' ? [] : this.$store.state.navBar
      return data
    }
  }
}
</script>

<style scoped lang="less">
.container {
  height: 100%;
  overflow: hidden;
  .mainHead{
    width: 100%;
    position: relative;
    background: var(--main-color);
    height: 80px;
    line-height: 80px;
    padding: 0 30px;
    box-sizing: border-box;
    span{
      font-size: 14px;
      color: #fff;
    }
    .logoImg{
      width: 55px;
      height: 35px;
      margin-right: 20px;
    }
    .title{
      font-size: 22px;
      color: #fff;
    }
    .avatar{
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .handlerSpan{
      cursor: pointer;
      margin-left: 20px;
    }
    .welcome{
      display: inline-block;
      padding-right: 20px;
      line-height: 14px;
      height: 14px;
      border-right: solid 1px #fff;
    }
  }
  .mainContainer{
    height: calc(100vh - 80px);
    background: #f7f8fb;
    min-width: 1008px;
    position: relative;
    .tags {
      position: absolute;
      // left: 270px;
      // top: 80px;
      // width: 100%;
      left: 0;
      top: 0;
      width: 100%;
      border-top: 1px solid #d8dce5;
      border-bottom: 1px solid #d8dce5;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
      overflow: hidden;
      z-index: 20;
    }
    .mainContent{
      position: relative;
      width: 100%;
      height: calc(100vh - 220px);
      padding: 60px 30px;
      overflow: auto;
      &>div{
        // height: 100%;
      }
    }
  }
}
</style>
